/**
 * leaving a shell here for future uses:
 * Create a constant with the name of the experiment
 * below is the shell of the object"
 * [experimentName]: {
 *   qa: {
 *    experimentId: 'guid here',
 *    variants: {
 *      control: {
 *        id: 'guid here'
 *      },
 *      // where N is the # of the variant. Variant1, variant2, etc
 *      variantN: {
 *        id: 'guid here'
 *      }
 *    },
 *    production: {
 *      // repeat as above
 *    }
 */
// eslint-disable-next-line import/prefer-default-export
export const EXPERIMENT_RETAILER_REGISTRIES_ON_MANAGE =
  'retailerRegistriesOnManage';
export const EXPERIMENT_VENMO_INTEGRATION = 'venmoIntegrationExperiment';
export const EXPERIMENT_GIFT_ADVISOR_ON_OVERVIEW = 'giftAdvisorOnOverview';
export const EXPERIMENT_GIFT_ADVISOR_V2 = 'giftAdvisorV2';
export const EXPERIMENT_FINANCIAL_ACCOUNTS = 'financialAccounts';
export const EXPERIMENT_ONBOARDING_ADD_GIFTS_DESIGN =
  'onboardingAddGiftsDesign';
export const EXPERIMENT_SHOP_PERSONALIZED_RECOMMENDATIONS =
  'shopPersonalizedRecommendations';

export const EXPERIMENT_CONFIGS = {
  [EXPERIMENT_RETAILER_REGISTRIES_ON_MANAGE]: {
    qa: {
      experimentId: '7b1d78b9-9c81-406d-a86e-8329f2854ffd',
      variants: {
        control: {
          id: '06a4315e-29e7-45c2-8867-524e79da4f39',
        },
        variant: {
          id: 'd6628723-b153-4e9b-a54a-fb71ad0a4994',
        },
      },
    },
    production: {
      experimentId: '7472c2ce-98b7-4643-ae4b-f5b19e7e4bb9',
      variants: {
        control: {
          id: 'e01ae21f-466b-4541-9e33-b206b6177620',
        },
        variant: {
          id: '2e628842-a063-42e5-b651-4df69e44bb48',
        },
      },
    },
  },
  [EXPERIMENT_VENMO_INTEGRATION]: {
    qa: {
      experimentId: '6ebf74dd-a3e7-41ea-ad9e-a6c50eebfd1c',
      variants: {
        control: {
          id: '02ee769c-a9df-4103-8f19-9726698f7cc2',
        },
        variant1: {
          id: '133e54eb-42d4-4c5e-8b6e-d0f6c218aeec',
        },
      },
    },
    production: {
      experimentId: '55de56ec-886c-4083-979d-5034e94abbe1',
      variants: {
        control: {
          id: '54d8e654-feab-4081-b478-7c74edd53166',
        },
        variant1: {
          id: '7ed67dbc-772c-4e84-bc94-ad47ecfd4f11',
        },
      },
    },
  },
  [EXPERIMENT_GIFT_ADVISOR_ON_OVERVIEW]: {
    qa: {
      experimentId: '11edac11-546c-4397-9812-983da9de9e0a',
      variants: {
        control: {id: 'f90988e0-41bd-46bc-9398-b609495bd629'},
        variant: {id: 'd8b92507-c5c8-465f-bea7-75b70e6efb4b'},
      },
    },
    production: {
      experimentId: '2ec2079f-154f-4324-82d3-f65b0a0b6b38',
      variants: {
        control: {id: 'e7641480-654f-4505-bef0-5b45b6e7ab08'},
        variant: {id: '34158dbe-40f4-4128-b402-ddfd1f37d381'},
      },
    },
  },
  [EXPERIMENT_GIFT_ADVISOR_V2]: {
    qa: {
      featureFlag: 'gift-advisor-v2-web',
      experimentId: 'de68d500-4155-476c-b3dd-f1e7d17c7d05',
      variants: {
        control: {id: '70e26c58-54b0-450b-b92e-bfac44a3fc71'},
        variant: {id: '557d2cfa-a0f1-4e05-9bac-a527d085b0fd'},
      },
    },
    production: {
      featureFlag: 'gift-advisor-v2-web',
      experimentId: 'e1930685-1048-4d8d-8a1a-f27c60d2d6b8',
      variants: {
        control: {id: '3072da18-f7e9-4347-90d1-a5076c46dfe3'},
        variant: {id: 'e9209a1d-1225-4856-be9b-26f24dbc1d05'},
      },
    },
  },
  [EXPERIMENT_FINANCIAL_ACCOUNTS]: {
    qa: {
      featureFlag: 'web-financial-accounts',
      experimentId: 'b7c9e6ac-b82e-4546-aaff-bb4d0836f7ae',
      variants: {
        control: {id: 'eb00ee6f-7289-4f09-89af-54cf0650340a'},
        variant: {id: '830bf832-874d-427e-a2fd-66abde659179'},
      },
    },
    production: {
      featureFlag: 'web-financial-accounts',
      experimentId: 'd1293ae7-c6ea-4561-98eb-ca0693f487ab',
      variants: {
        control: {id: '2cf76280-218c-4e82-a67c-aca9ac216087'},
        variant: {id: '8de62629-8350-409c-9b03-815c3b682fe3'},
      },
    },
  },
  [EXPERIMENT_ONBOARDING_ADD_GIFTS_DESIGN]: {
    qa: {
      experimentId: 'ab855124-ad6d-400a-84ab-f2e400c63295',
      variants: {
        control: {id: 'e47fb5b4-8093-492e-9f8a-155b8dbfb999'},
        variant1: {id: '612ffb24-96f2-4fb3-9334-f4ce1e6a08a4'},
      },
    },
    production: {
      experimentId: 'a9c885d4-6988-4d11-8d19-0dedeb9f17cc',
      variants: {
        control: {id: '06cb9ccc-43ad-45c6-8cb8-9af2cbe09102'},
        variant1: {id: '11802fb9-58a4-457e-97f8-33d46d566f28'},
      },
    },
  },
  [EXPERIMENT_SHOP_PERSONALIZED_RECOMMENDATIONS]: {
    qa: {
      featureFlag: 'shop-personalized-recommendations',
      experimentId: 'baa8947a-cfe0-4613-9883-88f69abcb9fd',
      variants: {
        control: {id: 'ff867d3d-b80c-4e8d-aa9b-d21f0cd05b12'},
        variant1: {id: 'b726f323-b95e-4230-99d0-8288df9306fc'},
        variant2: {id: '03798266-ffe6-4791-9860-081f351a7896'},
      },
    },
    production: {
      featureFlag: 'shop-personalized-recommendations',
      experimentId: '64013a0d-26fe-4a91-80a7-6ee260d1c7da',
      variants: {
        control: {id: '03680602-382d-4486-af52-96eb503ccc5a'},
        variant1: {id: '7d22216d-5cd4-4f63-83be-9446965ab03a'},
        variant2: {id: 'e3e7a5ac-3646-4d42-af0d-5bd69ddc9ec5'},
      },
    },
  },
};
